'use strict';

goog.provide("Ntry.entryPlayground");

Ntry.entryPlayground = function() {
    window.playground = this;
    var that = this;
    this._view = Ntry.interfaceManager.getDom('ntryPlayground');
    this.createDom();
    this.isResizing = false;
    this._currentCnt = 0;
    this._inited = false;

    this.parserSetted = false;

    this.mode = '0';
    this.code = null;
    this.availableCode = null;
    Ntry.addEventListener("run", this, this.convertCode);
    this.currentNumberText = Lang.Menus.used_blocks;
    this.goalNumberText = Lang.Menus.maximum;
};

(function(p){

    p.createDom = function () {
        var parent = this._view;
        var ce = Ntry.createElement;
        var colTop = ce('div', parent, null, 'ntryRightColTop');
        this._currentBlockNumber = ce('div', colTop, null, 'currentBlockNumber');
        this._goalBlockNumber = ce('div', colTop, null, 'goalBlockNumber');

        this.topbackground = ce('div', colTop, null, 'topbackground');

        var info = ce('div', parent, null, 'ntryRightColInfo');
        this._blockBoxText = ce('div', info, null, 'ntryRightColInfoLeft')
        this._blockBoxText.innerHTML = Lang.Menus.block_box;
        this._blockAssemblyText = ce('div', info, null, 'ntryRightColInfoRight');
        this._blockAssemblyText.innerHTML = Lang.Menus.block_assembly;

        var playground = ce('div', parent, null, 'ntryPlayground');
        this._blockMenu = ce('div', playground, 'ntryPlaygroundBlockMenu',
                             'ntryPlaygroundBlockMenu', 'blockMenuWorkspace', 'selectDisable');
        this._workspace = ce('div', playground, 'ntryPlaygroundWorkspace', 'ntryPlaygroundWorkspace');

        this.blockBg = ce('div', this._blockMenu, null, 'blockBackground');
        Entry.toast = new Entry.Toast();
        Entry.mainWorkspace = new Entry.Workspace(
            {
                'blockMenu': {
                    dom: 'ntryPlaygroundBlockMenu',
                    scroll: true
                },
                'board': {
                    dom: "ntryPlaygroundWorkspace"
                },
                "textType": Entry.Vim.TEXT_TYPE_JS
            }
        );
    };


    p.update = function() {
        if (!this.code) this.findCode();
        if (!this.availableCode) this.findAvailableCode();

        if (!this.parserSetted && this.code && this.availableCode) {
            Entry.mainWorkspace.vimBoard.setParserAvailableCode(
                this.code, this.availableCode
            );
            this.parserSetted = true;
        }
    };

    p.findCode = function() {
        var em = Ntry.entityManager;
        var entities = em.getEntitiesByComponent(
            Ntry.STATIC.CODE);

        var entity;
        for (var key in entities)
            var entity = entities[key];

        if (entity)
            this.code = em.getComponent(
                entity.id, Ntry.STATIC.CODE).code;

            if (this.code) {
                Entry.mainWorkspace.changeBoardCode(this.code);
                var threads = this.code.getThreads();
                var that = this;
                this.watchingThreads = threads;
                this.code.executeEndEvent.attach(this, function() {
                    Ntry.dispatchEvent("executeEnd",
                               Ntry.STATIC.COMPLETE);
                });

                this.code.changeEvent.attach(this, this.updateCurrentBlockNumber);
                this.updateCurrentBlockNumber();
                this.setMode(this.mode);
                if (threads && threads[0] && threads[0].getFirstBlock()) {
                    if (threads[0].getFirstBlock().x === 0)
                        setTimeout(function() {
                            this.code.board.alignThreads();
                        }.bind(this), 0);

                }
            }
    };

    p.findAvailableCode = function() {
        var code = Ntry.configManager.getConfig("availableCode");
        if (code) {
            this.availableCode = new Entry.Code(code);
            if (this.availableCode) {
                Entry.mainWorkspace.changeBlockMenuCode(this.availableCode);
            }
        }

    };

    p.loadConfig = function () {
        if (this.code) {
            this.code.clear();
            this.code = null;
        }
        if (this.availableCode) {
            this.availableCode.clear();
            this.availableCode = null;
        }
        if (!this._inited &&Entry.getMainWS()) {
            this._inited = true;
            Entry.getMainWS().changeEvent.attach(this, this.setMode)
        }
        var align = Ntry.configManager.getConfig("blockMenuAlign");
        Entry.mainWorkspace.addVimBoard('ntryPlaygroundWorkspace');
        Entry.mainWorkspace.blockMenu.setAlign(align);
        this.updateGoalBlockNumber(Ntry.configManager.getConfig("limitBlockCnt"));
        Entry.mainWorkspace.board.deActivateContextOption(Entry.Board.OPTION_CLEAR);

        Entry.Utils.bindBlockExecuteFocusEvents();
    };

    p.setMode = function(mode) {
        mode = mode === undefined ? Entry.getMainWS().getMode() : mode;
        this._mode = mode;
        this._mode = Number(mode) || 0;
        var goalCnt = Ntry.configManager.getConfig("limitBlockCnt");
        var currentCnt;

        switch(Number(mode)) {
            case Entry.Workspace.MODE_BOARD:
                this._blockBoxText.innerHTML = Lang.Menus.block_box;
                this._blockAssemblyText.innerHTML = Lang.Menus.block_assembly;
                this.currentNumberText = Lang.Menus.used_blocks;
                this.goalNumberText = Lang.Menus.maximum;
                var code = this.code;
                if (code) {
                    var FALSE = Entry.Block.DELETABLE_FALSE_LIGHTEN;
                    var block = code.getEventMap('start');
                    if (block) {
                        block[0].setDeletable(FALSE);
                        block[0].setCopyable(false);
                    }
                    block = code.getEventMap('define');
                    if (block && block[0]) {
                        block[0].setDeletable(FALSE);
                        block[0].setCopyable(false);
                    }
                }
                break;
            case Entry.Workspace.MODE_VIMBOARD:
                this._blockBoxText.innerHTML = Lang.Menus.command_box;
                this._blockAssemblyText.innerHTML = Lang.Menus.command_assembly;
                this.currentNumberText = Lang.Menus.used_command;
                this.goalNumberText = Lang.Menus.maximum_command;
                goalCnt--;
                currentCnt = this._currentCnt;
                break;
        }

        this.updateCurrentBlockNumber(currentCnt);
        this.updateGoalBlockNumber(goalCnt);
        Entry.windowResized.notify();

    };


    p.convertCode = function() {
        var workspace = Entry.mainWorkspace;
        if (workspace) {
            workspace.textToCode();
            setTimeout(function(){
                this.updateCurrentBlockNumber();
            }.bind(this));
        }
    };

    p.updateCurrentBlockNumber = function (num) {
        if (!this.code) return;
        if (num === undefined) {
            var code = this.code;
            var startThread = code.getEventMap('start');
            if (!startThread) return;
            if (startThread && startThread[0]) {
                startThread = startThread[0].getThread();
                num = startThread.getBlockList(true).length;
            }

            var defineThread = code.getEventMap('define');
            if (defineThread && defineThread[0]) {
                defineThread = defineThread[0].getThread();
                num += defineThread.getBlockList(true).length;
            }
        }

        if (Entry.mainWorkspace.getMode() === Entry.Workspace.MODE_VIMBOARD)
            num--;

        if (num !== undefined) {
            this._currentCnt = num;
            this._currentBlockNumber.innerHTML = this.currentNumberText + ': ' + num;
        }
    };

    p.updateGoalBlockNumber = function (num) {
        this._goalBlockNumber.innerHTML = this.goalNumberText + ': ' + num;
    };

})(Ntry.entryPlayground.prototype);


